module.exports = __webpack_public_path__ + "static/img/detailImgYt.060cb48.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgYt.png
// module id = 0tBk
// module chunks = 7